var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0c2.005 0 3.887.792 5.304 2.233A7.655 7.655 0 0 1 15 7.628a7.704 7.704 0 0 1-1.765 4.912L8.12 19.678a.771.771 0 0 1-.624.322.771.771 0 0 1-.623-.322L1.76 12.54A7.728 7.728 0 0 1 0 7.628a7.64 7.64 0 0 1 2.196-5.395A7.394 7.394 0 0 1 7.5 0zm0 5.675c-1.11 0-2.01.915-2.01 2.045 0 1.129.9 2.044 2.01 2.044 1.11 0 2.01-.915 2.01-2.044 0-1.13-.9-2.045-2.01-2.045z",
    fillRule: "nonzero"
  })));
};
export default SvgLocation;